import { defineStore } from 'pinia';


export const useSettingsStore = defineStore('settings', {
  persist: true,
  state: () => ({ 
    disable_numeric_keyboard: false,
  }),
});
